import { useUserSettings } from '../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import BulkOpsDrawerDetailsOld from './bulk-ops-drawer-details-old';
import BulkOpsDrawerDetails from './bulk-ops-drawer-details';

export default function BulkOpsDrawerDetailsPage() {
  const { features } = useUserSettings();
  const isUiEnhancementEnabled = isFeatureEnabled(
    'uiEnhancementPhase2',
    features
  );
  return isUiEnhancementEnabled ? (
    <BulkOpsDrawerDetails />
  ) : (
    <BulkOpsDrawerDetailsOld />
  );
}
